import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getInteriorState } from '../../thunks/vehicleProThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
import { clearVehicleProKey } from '../../thunkKeys/vehicleProThunksKeys';

const SLICE_NAME = 'interiorState';

export const interiorStateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearInteriorState(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getInteriorState });
        builder.addCase(
            clearVehicleProKey,
            () => commonInitialState,
        );
    },
});

export const { clearInteriorState } = interiorStateSlice.actions;

export const interiorState = interiorStateSlice.reducer;
